// ** Reducers Imports
import NiceModal from "@ebay/nice-modal-react";
import navbar from "./navbar";
import layout from "./layout";
import layoutStatus from "./layoutStatus";
import maintenance from "./maintenance";
import sidebar from "./sidebar";
import fonts from "@components/PixelPdf/store";
import dynamicTabs from "@components/PixelTabs/store";
import loginUser from "@userAuth/Login/store";
import toastify from "./actions/Notify";
import modalDirty from "@components/DynamicModal/store";
import systemTypes from "@src/views/SystemSettings/SystemConfigurations/DropdownLists/store";
import coreForm from "@components/Form/store";
import company from "@src/views/SystemSettings/CompanyAccount/store";

const nicemodals = NiceModal.reducer;
const rootReducer = { nicemodals, toastify, navbar, layout, layoutStatus, maintenance, sidebar, loginUser, modalDirty, systemTypes, dynamicTabs, coreForm, company, fonts };
export default rootReducer;
